"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlatColumnTree = exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _putAfterItem = _interopRequireDefault(require("./putAfterItem.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var appDefs = window.cccisd.appDefs || {};
var levels = {
  groups: {
    rows: (0, _get2["default"])(appDefs, 'pawn.groups', []).map(function (item) {
      return {
        value: item.handle,
        label: item.label
      };
    }),
    key: 'group.groupId',
    initialColumns: [{
      id: 1,
      name: 'group.groupId',
      query: 'group.groupId',
      label: 'Group ID',
      type: 'number',
      alignment: 'left',
      filter: true,
      sort: true
    }, {
      id: 2,
      name: 'group.label',
      query: 'group.label',
      label: 'Label',
      type: 'string',
      alignment: 'left',
      filter: true,
      sort: true
    }],
    tree: [{
      label: 'About group',
      children: ['group.groupId', 'group.label']
    }],
    ancestorKey: 'parentGroups'
  },
  roles: {
    rows: (0, _get2["default"])(appDefs, 'pawn.roles', []).map(function (item) {
      return {
        value: item.handle,
        label: item.label
      };
    }),
    key: 'pawn.pawnId',
    initialColumns: [{
      id: 1,
      name: 'pawn.pawnId',
      query: 'pawn.pawnId',
      label: 'System ID',
      type: 'number',
      alignment: 'left',
      filter: true,
      sort: true
    }],
    tree: [{
      label: 'Respondent info',
      children: ['pawn.pawnId', 'pawn.importId', 'pawn.createdDate', 'pawn.roleName']
    }, {
      label: 'Respondent fields',
      children: []
    }, {
      label: 'Metrics Pawn Group',
      children: ['parentGroup.anyGroup.group.groupId', 'parentGroup.anyGroup.group.groupType', 'parentGroup.anyGroup.group.label']
    }],
    ancestorKey: 'membersOf'
  }
};
var allColumns = function () {
  if (process.env.NODE_ENV === 'test') {
    return {};
  }
  var columns = {
    'pawn.pawnId': {
      label: 'System ID',
      type: 'number'
    },
    'pawn.importId': {
      label: 'Import ID',
      type: 'number'
    },
    'pawn.createdDate': {
      label: 'Created Date',
      type: 'string'
    },
    'pawn.roleName': {
      label: 'Role',
      type: 'string'
    },
    'group.groupId': {
      label: 'Group ID',
      type: 'number'
    },
    'group.label': {
      label: 'Label',
      type: 'string'
    },
    'user.username': {
      label: 'Username',
      type: 'string'
    },
    'user.firstName': {
      label: 'First Name',
      type: 'string'
    },
    'user.lastName': {
      label: 'Last Name',
      type: 'string'
    },
    'user.fullName': {
      label: 'Full Name',
      type: 'string'
    },
    'user.fullNameWithEmail': {
      label: 'Full Name with Email',
      type: 'string'
    },
    'user.fullNameWithUsername': {
      label: 'Full Name with Username',
      type: 'string'
    },
    'user.email': {
      label: 'Email',
      type: 'string'
    },
    'user.phone': {
      label: 'Phone',
      type: 'string'
    },
    'user.activated': {
      label: 'Activated',
      type: 'boolean'
    },
    'user.hasLoggedIn': {
      label: 'Has Logged In?',
      type: 'boolean'
    },
    'user.lastLoginDate': {
      label: 'Last Login Date',
      type: 'string'
    },
    'parentGroup.anyGroup.group.groupId': {
      label: 'Metrics Pawn Group ID',
      type: 'number'
    },
    'parentGroup.anyGroup.group.groupType': {
      label: 'Metrics Pawn Group Type',
      type: 'string'
    },
    'parentGroup.anyGroup.group.label': {
      label: 'Metrics Pawn Group Label',
      type: 'string'
    }
  };
  appDefs.pawn.fields.forEach(function (field) {
    columns["fields.".concat(field.handle)] = {
      label: field.label,
      type: field.data_type
    };
  });
  appDefs.pawn.groups.forEach(function (group) {
    columns["descendantGroups.".concat(group.handle, "Count")] = {
      label: "".concat(group.label, " count"),
      type: 'number'
    };
  });
  appDefs.pawn.roles.forEach(function (role) {
    columns["childRoles.".concat(role.handle, "Count")] = {
      label: "".concat(role.label, " count"),
      type: 'number'
    };
    columns["descendantRoles.".concat(role.handle, "Count")] = {
      label: "".concat(role.label, " count"),
      type: 'number'
    };
  });
  return columns;
}();
var getFields = function getFields() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var level = arguments.length > 1 ? arguments[1] : undefined;
  var rows = arguments.length > 2 ? arguments[2] : undefined;
  var levelInfo = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
    return item.handle === rows;
  });
  return levelInfo && levelInfo.fields ? levelInfo.fields.map(function (name) {
    return _objectSpread({
      id: "".concat(prefix, "fields.").concat(name)
    }, allColumns["fields.".concat(name)]);
  }) : [];
};
var getFlatColumnTree = exports.getFlatColumnTree = function getFlatColumnTree(level, rows) {
  var result = {};
  var tree = getColumnTree({
    level: level,
    rows: rows
  });
  function traverse(node) {
    node.forEach(function (item, index) {
      if (item.children) {
        traverse(item.children);
      } else {
        result[item.id] = item;
      }
    });
  }
  traverse(tree);
  return result;
};
var getColumnTree = function getColumnTree() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 'roles' : _ref$level,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 'wrong' : _ref$rows,
    _ref$projectFields = _ref.projectFields,
    projectFields = _ref$projectFields === void 0 ? {} : _ref$projectFields;
  var tree = _toConsumableArray(levels[level].tree);
  if (level === 'roles') {
    var infoItem = tree.find(function (child) {
      return child.label === 'Respondent info';
    });
    var fieldsItem = tree.find(function (child) {
      return child.label === 'Respondent fields';
    });
    var metricsItem = tree.find(function (child) {
      return child.label === 'Metrics Pawn Group';
    });
    if (infoItem) {
      // Get user information if it's a fortress user
      var info = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
        return item.handle === rows;
      });
      if (info && info.isFortressUser) {
        (0, _putAfterItem["default"])(infoItem.children, 'pawn.pawnId', ['user.username', 'user.firstName', 'user.lastName', 'user.fullName', 'user.fullNameWithEmail', 'user.fullNameWithUsername', 'user.email', 'user.phone', 'user.activated', 'user.hasLoggedIn', 'user.lastLoginDate']);
      }
    }

    // Get fields
    if (fieldsItem) {
      if (rows === 'respondent') {
        var fields = getFields('', level, rows).filter(function (item) {
          return item.id in projectFields;
        }).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            label: projectFields[item.id].value
          });
        });
        if (fields.length > 0) {
          var _fieldsItem$children;
          (_fieldsItem$children = fieldsItem.children).unshift.apply(_fieldsItem$children, _toConsumableArray(fields));
        }
      } else {
        var _fields = getFields('', level, rows);
        if (_fields.length > 0) {
          var _fieldsItem$children2;
          (_fieldsItem$children2 = fieldsItem.children).unshift.apply(_fieldsItem$children2, _toConsumableArray(_fields));
        }
      }
    }
    if (metricsItem) {
      var _info = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
        return item.handle === 'metricspawn';
      });
      if (_info && _info.importantFields) {
        var _metricsItem$children;
        (_metricsItem$children = metricsItem.children).push.apply(_metricsItem$children, _toConsumableArray(_info.importantFields.map(function (field) {
          return {
            id: field.path,
            label: field.label,
            type: 'string'
          };
        })));
      }
    }
  }
  var addedGroups = new Set();

  // Get ancestors
  function getAncestors() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var level1 = arguments.length > 1 ? arguments[1] : undefined;
    var rows1 = arguments.length > 2 ? arguments[2] : undefined;
    var info = (0, _get2["default"])(appDefs, "pawn.".concat(level1), []).find(function (item) {
      return item.handle === rows1;
    });
    var key = levels[level1].ancestorKey;
    if (info && info[key] && info[key].length > 0) {
      var _iterator = _createForOfIteratorHelper(info[key]),
        _step;
      try {
        var _loop = function _loop() {
          var group = _step.value;
          if (addedGroups.has(group)) {
            return 1; // continue
          }
          var groupInfo = appDefs.pawn.groups.find(function (item) {
            return item.handle === group;
          });
          if (groupInfo) {
            addedGroups.add(group);
            tree.push({
              label: groupInfo.label,
              children: [].concat(_toConsumableArray(['group.groupId', 'group.label'].map(function (name) {
                return _objectSpread(_objectSpread({}, allColumns[name]), {}, {
                  id: "".concat(prefix, "ancestorGroups.").concat(group, ".").concat(name),
                  label: "".concat(groupInfo.label, " ").concat(allColumns[name].label)
                });
              })), [{
                label: 'Fields',
                children: getFields("".concat(prefix, "ancestorGroups.").concat(group, "."), 'groups', group)
              }])
            });
            getAncestors('', 'groups', group);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  if (rows !== 'respondent') {
    getAncestors('', level, rows);
  }

  // Get descendant
  if (level === 'groups') {
    var childRoles = [];
    var childGroups = [];
    var _getDescendants = function getDescendants(rows1) {
      var info = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
        return item.handle === rows1;
      });
      if (info && info.containsRoles) {
        childRoles.push.apply(childRoles, _toConsumableArray(info.containsRoles));
      }
      if (info && info.childGroups) {
        childGroups.push.apply(childGroups, _toConsumableArray(info.childGroups));
        info.childGroups.forEach(_getDescendants);
      }
    };
    _getDescendants(rows);
    if (childRoles.length > 0) {
      tree.push({
        label: 'Role Counts',
        children: childRoles.map(function (child) {
          return "descendantRoles.".concat(child, "Count");
        })
      });
    }
    if (childGroups.length > 0) {
      tree.push({
        label: 'Group Counts',
        children: childGroups.map(function (child) {
          return "descendantGroups.".concat(child, "Count");
        })
      });
    }
  }

  // Get child roles
  if (level === 'roles') {
    var _info2 = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
      return item.handle === rows;
    });
    if (_info2 && _info2.childRoles && _info2.childRoles.length > 0) {
      tree.push({
        label: 'Role Counts',
        children: _info2.childRoles.map(function (child) {
          return "childRoles.".concat(child, "Count");
        })
      });
    }
  }

  // Add sort information
  (function () {
    var sort = 1;
    function traverse(node) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      node.forEach(function (item, index) {
        if (typeof item === 'string') {
          node[index] = _objectSpread({
            id: item,
            sort: sort++
          }, allColumns[item]);
        } else if (item.children) {
          item.id = "".concat(prefix).concat(item.label);
          traverse(item.children, "".concat(prefix).concat(item.label, "."));
        } else {
          item.sort = sort++;
        }
      });
    }
    traverse(tree);
  })();

  // Remove duplicates
  (function () {
    function traverse(node) {
      node.forEach(function (item) {
        if (item.children) {
          var ids = new Set();
          item.children = item.children.filter(function (child) {
            if (ids.has(child.id)) {
              return false;
            }
            ids.add(child.id);
            return true;
          });
          traverse(item.children);
        }
      });
    }
    traverse(tree);
  })();
  return tree;
};
var _default = exports["default"] = getColumnTree;